let degrees = '';
let topSize = '';
let bottomType = '';

function slugify(string) {
  const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;';
  const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with ‘and’
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

const checkStorageForBasketData = () => {
  degrees = localStorage.getItem('basketFinderInputAngle');
  topSize = localStorage.getItem('basketFinderInputTop');
  bottomType = localStorage.getItem('basketFinderInputBottomType');

  if (degrees != null && degrees != undefined) {
    degrees = slugify(degrees);
    let degreesVal = degrees.replace('-', '°-');
    degreesVal = degreesVal + '°';
    $(`.js-basket-finder-input-angle-btn[value=${degreesVal}]`).addClass('border-grey-300');
  } else {
    degrees = '';
  }

  if (topSize != null) {
    topSize = slugify(topSize);
    $('.js-basket-finder-input-top').val(topSize);
  } else {
    topSize = '';
  }

  if (bottomType != null) {
    bottomType = slugify(bottomType);
    $(`.js-basket-finder-input-bottom-type[data-bottom-type=${bottomType}]`)
      .addClass('border-grey-300')
      .addClass('selected');
  } else {
    bottomType = '';
  }
};

checkStorageForBasketData();

function searchForBasket(degreesIn = degrees, topSizeIn = topSize, bottomTypeIn = bottomType) {
  $('.js-basket-search-results').html('<h2>Searching</h2>');
  degreesIn = slugify(degreesIn);
  bottomTypeIn = slugify(bottomTypeIn);

  const getJSONUrl = `/basket-search-results/${degreesIn}/${topSizeIn}/${bottomTypeIn}`;

  $('.js-basket-search-results').html('Searching…');

  $.ajax({
    type: 'GET',
    url: getJSONUrl,
    dataType: 'json',
    cache: false,
    success: function(json) {
      $('.js-basket-search-results').html('<h2>Results</h2>');

      if (json.results == undefined) {
        $.each(json, function(index) {
          let bottomTypes = '';
          this.bottomTypes.forEach(item => {
            bottomTypes += `${item},`;
          });

          bottomTypes = bottomTypes.replace(/\,$/, '');

          const resultsMessage = `
          <div class="flex justify-center text-left max-w-50 mx-auto items-center">
          <div class="w-1/2 pr-2 flex">
          <div class="w-15 ml-auto">
          <div class="aspect-ratio aspect-ratio--bottom">
            <img src="${this.basketCategoriesIllustration}" alt="${this.basketCategories}"/>
          </div>
          </div>
          </div>
          <div class="w-1/2 my-auto">
          <h2 class="w-full">
            ${this.basketCategories}
          </h2>
          <a class="js-add-to-order-btn btn btn--sm btn--blue"
          data-basket-categories="${this.basketCategories}"
          data-bottom-types="${bottomTypes}"
          data-burlap-liner="${this.burlapLiner}"
          data-burlap-square="${this.burlapSquare}"
          data-pallet-count-heavy="${this.palletCountHeavy}"
          data-pallet-count-light="${this.palletCountLight}"
          data-pallet-count-standard="${this.palletCountStandard}"
          data-rowid="row-${index}"
          data-top-size="${this.top}"
          data-taper="${this.taper}"
          href="#">Add</a>
          </div>
          </div>
          `;

          if (index == 'item1') {
            $('.js-basket-search-results').html('<p class="mb-0">These baskets should be a good fit for you:</p>');
          } else {
          }
          $('.js-basket-search-results').append(resultsMessage);
        });
      } else {
        let resultsMessage = `
                <h2>No Results for:</h2>
                <p>${degreesIn}, ${topSizeIn}, ${bottomTypeIn}</p>
                <p><a class="link" href="#basket-search">Search Again</a></p>
                <p><a class="link" href="/wire-baskets">View all baskets</a></p>
                `;
        $('.js-basket-search-results').html(resultsMessage);
      }
    },
    error: function(request, status, error) {
      $('.js-basket-search-results').html(`
            <h2>Something went wrong 😭</h2>
            <p><a class="link" href="#basket-search">Search Again</a></p>
            <p><a class="link" href="/wire-baskets">View all baskets</a></p>
            `);
    }
  });
}

$('.js-basket-finder-input-angle-btn').on('click', function(e) {
  degrees = $(this).val();
  localStorage.setItem('basketFinderInputAngle', degrees);
  $('.js-basket-finder-input-angle-btn').removeClass('border-grey-300');
  $(this).addClass('border-grey-300');

  $('html, body').animate(
    {
      scrollTop: $('#top-size').offset().top
    },
    1000
  );

  return false;
});

$('.js-basket-finder-input-top').on('change', function(e) {
  topSize = this.value;
  localStorage.setItem('basketFinderInputTop', topSize);

  $('html, body').animate(
    {
      scrollTop: $('#bottom-type').offset().top
    },
    1000
  );

  return false;
});

$('.js-basket-finder-input-bottom-type').on('click', function(e) {
  bottomType = $(this).data('bottom-type');
  localStorage.setItem('basketFinderInputBottomType', bottomType);
  $('.js-basket-finder-input-bottom-type').removeClass('border-grey-300');
  $(this).addClass('selected');
  $(this).addClass('border-grey-300');

  $('html, body').animate(
    {
      scrollTop: $('#search').offset().top
    },
    1000
  );

  return false;
});

$('.js-run-basket-search').on('click', function(e) {
  e.preventDefault;
  searchForBasket(degrees, topSize, bottomType);

  $('html, body').animate(
    {
      scrollTop: $('#results').offset().top
    },
    1000
  );

  return false;
});

$('.js-basket-search-results').on('click', 'a[href="#basket-search"]', function() {
  $('html, body').animate(
    {
      scrollTop: $('#basket-search').offset().top
    },
    1000
  );
});
